import React, {Fragment, ReactElement, useEffect, useState} from 'react';
import home from '../../../assets/images/home.svg';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../../redux/globalSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {useHistory} from 'react-router-dom';
import {BackButtonAction} from '../../../core/utils/string.util';
import {customerProfile} from '../../../redux/customerSearchSlice';
import {resetState as resetMisisngSizeApi} from '../../../redux/missingSizeApiSlice';
import {
  notifyCustomer,
  notifyData,
  loading,
  error,
  notifyStatus,
  resetState as resetNotifyData,
} from '../../../redux/notifyCustomerSlice';
import {
  productSizeData,
  MissingSizeData,
} from '../../../redux/missingSizeApiSlice';
import cogoToast from 'cogo-toast';
import ErrorToast from '../../../components/notifications/ErrorToast';
import {
  getAccessToken,
  getColor,
  getSize,
} from '../../../core/localstorage-data';
import { notifyAvailability } from '../../../lib/tagmanager';

const Notify = (): ReactElement => {
  const [locationKeys, setLocationKeys] = useState([]);
  const size = getSize();
  const color = getColor();
  const notifyCustomerData = useAppSelector(notifyStatus);
  const dataIsLoading = useAppSelector(loading);
  const errorInNotify = useAppSelector(error);
  const dataOfNotity = useAppSelector(notifyData);
  const navigate = useHistory();
  const userDetail = useAppSelector(customerProfile);
  const productDetail = useAppSelector(MissingSizeData);
  const itemDetail = useAppSelector(productSizeData);
  const accessToken = getAccessToken();
  const dispatch = useAppDispatch();
  useEffect(() => {
    return navigate.listen(location => {
      if (navigate.action === 'PUSH') {
        setLocationKeys([location.key]);
      }

      if (navigate.action === 'POP') {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);

          // Handle forward event
        } else {
          setLocationKeys(keys => [location.key, ...keys]);

          // Handle back event
          navigate.replace('missingsizes');
        }
      }
    });
  }, [locationKeys]);

  useEffect(() => {
    if (size === null) {
      navigate.replace('missingsizes');
    }
    if (color === null) {
      navigate.replace('missingsizes');
    }
    if (productDetail.price.value === 0) {
      navigate.replace('missingsizes');
      return;
    }
    dispatch(setAppBarTitle('Find missing size'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.TO_RESETMISSING_SIZE));

    return () => {
      // Clean up the subscription
      localStorage.removeItem('color');

      localStorage.removeItem('size');
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));
    };
  }, []);
  useEffect(() => {
    if (errorInNotify != '') {
      cogoToast.error(
        <ErrorToast title="Error" description="Something went wrong, Please try again." />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
    if (dataIsLoading === false && notifyCustomerData === 'SUCCESS') {
      console.log('data');
      dispatch(resetNotifyData());
      localStorage.removeItem('color');
      dispatch(resetMisisngSizeApi());
      localStorage.removeItem('size');
      navigate.replace('./home');
      // dispatch(setCurrentPage(MissingSizePage.BarCodePage));
      //navigate.push('./home');
    }
  }, [notifyCustomerData, errorInNotify, dataIsLoading, dataOfNotity]);

  const buttonHandler = () => {
    const baseProduct = itemDetail.base_product.split('-');
    const parameters = {
      payload: {
        data: {
          size: size,
          color: color,
          name: productDetail.name,
          code: baseProduct,
        },
        cardNumber: userDetail.cardNumber,
      },

      accessToken: accessToken,
    };
    notifyAvailability(baseProduct,size,color,productDetail.name);
    // dispatch(setCurrentPage(MissingSizePage.BarCodePage));
    dispatch(notifyCustomer(parameters));
    dispatch(resetMisisngSizeApi());
  };
  return (
    <Fragment>
      <div className="container mx-auto z-10 px-8 bg-color">
        <div className="w-auto ">
          <div className="mt-8 grid place-items-center">
            <svg
              className="w-20 h-20 text-white rounded-full bg-green_zero "
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="4"
                d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="mt-6 grid place-items-center">
            <span className="font-roboto text-2xl text-center">
              Thank you for your interest!
            </span>
          </div>
          <div className="mt-6 grid place-items-center">
            <span className="font-roboto font-thin text-center">
              <span className="text-black text-opacity-50">Size</span> &lsquo;
              <span className="font-medium">{size}</span>&lsquo;
              <span className="text-black text-opacity-50">
                {' '}
                is not available with us.
              </span>
            </span>
          </div>
          <div className="font-roboto font-thin text-center">
            <span className="text-black text-opacity-50">
              We will notify you when available.
            </span>
          </div>

          <div>
            <div className=" flex justify-between">
              <button
                className="text-white h-12 mt-40 px-3 w-full rounded-radius10 border-solid border border-gray-400 grid place-items-center focus:outline-none text-center font-medium
                secondary normal"
                onClick={buttonHandler}>
                <div className="flex">
                  <div>
                    <img src={home} />
                  </div>
                  <div className="ml-2">
                    {' '}
                    <span className="text-roboto text-black">Home</span>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default Notify;
